import React from 'react';
import { CHECKOUT_URL } from '../data/product';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Ball Orange is the single action color on this page, against Night Navy.
 * Turf green marks what's included; crimson is reserved for tension.
 */
export function CtaButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-5 text-xl sm:text-2xl rounded-2xl min-h-[64px]' : 'px-5 py-3 text-sm rounded-xl';
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2 bg-gold text-center font-display font-bold uppercase tracking-wide text-gold-ink shadow-card transition-[background-color,box-shadow] duration-150 ease-out hover:bg-gold-hover hover:shadow-lift focus:outline-none focus-visible:ring-4 focus-visible:ring-white/60 ${sizing} ${className}`} data-id="element-91" data-mp="10a3sc6vj9iy5">
      {children}
    </a>;
}